import { useSelector } from 'react-redux';
import { T } from 'shared/helpers';

/** @returns {JSX.Element} */
export default function WithPermission(
  /** @type {import('react').PropsWithChildren<{ permission: AvailablePermissions }>} */ {
    permission,
    children,
  },
) {
  const user = useSelector((state) => state.user.data);
  const roles = T(user.roles, []);

  const hasRole = roles.find((r) =>
    r.permissions.find((p) => p.name === permission),
  );

  return hasRole ? children : null;
}
